import { makeStyles } from '@material-ui/core/styles'

export const MyExpensesStyles = makeStyles((theme) => ({
  container: {
    padding: 0,
    margin: 0,
    height: 428,
    maxHeight: 428,
    overflowY: 'auto',
    overflowX: 'hidden',
    [theme.breakpoints.down(769)]: {
      height: 'calc(100dvh - 246px)',
    },
  },
  checkCircleIcon: {
    color: theme.palette.base.green,
  },
  noExpenseData: {
    marginTop: theme.spacing(5),
  },
  expenseListRecordsContainer: {
    margin: 0,
  },
  expenseObject: {
    width: 'calc(100% - 8px)',
    height: 70,
    margin: theme.spacing(0.5),
    backgroundColor: theme.palette.backgroundColor.ternary,
    '&:focus': {
      border: `2px solid ${theme.palette.button.focusOutline}`,
    },
  },
  // removed as items are not clickable
  // expenseObjectLink: {
  //   width: '100%',
  //   height: '100%',
  //   display: 'block',
  //   '&:focus': {
  //     border: `2px solid ${theme.palette.button.focusOutline}`,
  //   },
  //   '&:hover': {
  //     cursor: 'pointer',
  //   },
  // },
  expenseManagementButton: {
    color: theme.palette.base.white,
    backgroundColor: theme.palette.base.green,
    margin: '0 auto',
    marginBottom: 8,
    '&:hover': {
      backgroundColor: theme.palette.base.greenHover,
    },
  },
  paidColor: {
    color: theme.palette.base.green,
  },
  removeCircleIcon: {
    color: theme.palette.base.red,
  },
  unpaidColor: {
    color: theme.palette.base.red,
  },
}))

export default MyExpensesStyles
